/**
 * @fileoverview Skip link for keyboard users (accessibility).
 * @summary First focusable element; allows skipping navigation to main content.
 * @package PlayItNow
 * @module apps/front/components/SkipLink
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 * @license EULA
 */

import { useTranslation } from '@/contexts/I18nContext'

/**
 * @summary Renders a skip link to #main-content (visually hidden until focused).
 */
export function SkipLink() {
  const { t } = useTranslation()
  return (
    <a href="#main-content" className="skip-link">
      {t('common.skipToContent')}
    </a>
  )
}
